import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Row, Typography, Button, Space } from 'antd';
import { ReactComponent as FemaleScreeningSvg } from '../../../../assets/icons/sign-up/female-screening.svg';

const { Title, Paragraph } = Typography;

const styles = {
  text1: {
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "17px",
    textAlign: "center",
    color: "#15A9E1"
  },
  text2: {
    fontWeight: "300",
    fontSize: "18px",
    lineHeight: "26px",
    textAlign: "center",
    color: "#404047"
  },
  text3: {
    fontWeight: "300",
    fontSize: "14px",
    lineHeight: "20px",
    textAlign: "center",
    color: "#8C8C8C"
  }
}

function MobileScreeningRequestScreen() {
  const { t } = useTranslation(['sign-up', 'common']);
  const history = useHistory();

  const onConfirm = () => {
    history.push('/sign-up/guest/finish')
  }

  const onCancel = () => {
    history.push('/sign-up/guest/take-health-screening/allergies')
  }

  return (
    <>
      <Row justify="center" style={{ padding: 0, marginBottom: 23 }}>
        <Title level={4} style={styles.text1}>
          {t('sign-up:guest.yourAlmostDone')}
        </Title>
      </Row>
      <Box display="flex" justifyContent="center">
        <FemaleScreeningSvg style={{ margin: '20', maxWidth: '80%' }} />
      </Box>
      <Box marginTop={30}>
        <Box marginBottom={45}>
          <Paragraph style={styles.text2}>
            {t('sign-up:guest.wouldYouInitialHealth')}
          </Paragraph>
        </Box>
        <Box marginBottom={50}>
          <Paragraph style={styles.text3}>
            {t('sign-up:guest.theScreeningTake3Minute')}
          </Paragraph>
        </Box>
        <Space direction="vertical" style={{ width: '100%' }}>
          <Button
            htmlType="button"
            type="primary"
            size="large"
            onClick={onCancel}
            block
          >
            {t('sign-up:guest.takeHealthScreening')}
          </Button>
          <Button
            htmlType="button"
            type="primary"
            size="large"
            onClick={onConfirm}
            block
            ghost
          >
            {t('sign-up:guest.skipForNow')}
          </Button>
        </Space>
      </Box>
    </>
  );
}

export default MobileScreeningRequestScreen;
